export enum FeedbackCategory {
    Accurate,
    UpToDate,
    Helpful,
    FollowedInstructions,
    GoodSources,
    OutOfDate,
    Inaccurate,
    WrongSources,
    TooLong,
    TooShort,
    Other,
}

export const FeedbackCategoryDisplayNames: Record<FeedbackCategory, string> = {
    [FeedbackCategory.Accurate]: "Accurate",
    [FeedbackCategory.UpToDate]: "Up to date",
    [FeedbackCategory.Helpful]: "Helpful",
    [FeedbackCategory.FollowedInstructions]: "Followed instructions",
    [FeedbackCategory.GoodSources]: "Good sources",
    [FeedbackCategory.OutOfDate]: "Out of date",
    [FeedbackCategory.Inaccurate]: "Inaccurate",
    [FeedbackCategory.WrongSources]: "Wrong sources",
    [FeedbackCategory.TooLong]: "Too long",
    [FeedbackCategory.TooShort]: "Too short",
    [FeedbackCategory.Other]: "Other",
};
